export class DwgFetcher {
  constructor(url) { this.url = url }
  async Fetch() {
    throw new Error('Lector DWG aún no implementado')
  }
}
